module.exports = __webpack_public_path__ + "static/media/elo.a81d60fc.svg";